/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

document.title = "DigiCentral"
import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from 'axios'
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'



// Auth0 Plugin
// import AuthPlugin from "./plugins/auth";
// Vue.use(AuthPlugin);

//UUID
import UUID from 'vue-uuid';
Vue.use(UUID);

import jQuery from 'vue-jquery'
Vue.use(jQuery);

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);



// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// VueCytoscape
import VueCytoscape from 'vue-cytoscape'
import 'vue-cytoscape/dist/vue-cytoscape.css'

// ScrollTo
import VueScrollTo from 'vue-scrollto'

// V-Uploader
import vUploader from 'v-uploader';

// Feather font icon
require('./assets/css/iconfont.css')

// Vue Analytics
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-159115893-5',
  router
});

//Alternative Check box, Input box & radio button
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import CryptoJs from 'crypto-js'
Vue.use(CryptoJs)

import VueClockPicker from '@pencilpix/vue2-clock-picker';
Vue.use(VueClockPicker);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// New drag and drop question
import VueDragDrop from 'vue-drag-drop';
Vue.use(VueDragDrop);

// Vue SweetAlert
import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
  namespace: 'touch'
});

import { MonthPickerInput } from 'vue-month-picker';
Vue.use(MonthPickerInput);


Vue.prototype.$VUE_APP_VIDEO_CAPTURE_URL = process.env.VUE_APP_VIDEO_CAPTURE_URL;
Vue.prototype.$VUE_APP_HLS_PLAYER_URL = process.env.VUE_APP_HLS_PLAYER_URL;
Vue.prototype.$VUE_APP_HLS_PLAYER_URL_LIBRARY = process.env.VUE_APP_HLS_PLAYER_URL_LIBRARY;
Vue.prototype.$VUE_APP_HLS_PLAYER_URL_LIVESTREAM = process.env.VUE_APP_HLS_PLAYER_URL_LIVESTREAM;
Vue.prototype.$VUE_APP_ROOT_API = process.env.VUE_APP_ROOT_API;
Vue.prototype.$VUE_APP_SIGNALR = process.env.VUE_APP_SIGNALR;
Vue.prototype.$VUE_APP_SITE_WITH_CONTENT = process.env.VUE_APP_SITE_WITH_CONTENT;

Vue.prototype.$VUE_APP_ENVIROMENT = process.env.VUE_APP_ENVIROMENT;

Vue.prototype.$isProductionEnv = function() {
  if(this.$VUE_APP_ENVIROMENT == 'PRODUCTION'){
    return true;
  }else{
    return false;
  }
}

Vue.prototype.$buildUrl = function(path) {
  return this.$VUE_APP_ROOT_API + "/" + path;
}

Vue.prototype.$getAccessToken = function () {
  return localStorage.getItem("accessToken");
}

Vue.prototype.$getSiteId = function() {
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].siteId;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).siteId;
  }
  else
    return 0;
  // return 35;
}

Vue.prototype.$getSiteIdWithContent = function() {
  return this.$VUE_APP_SITE_WITH_CONTENT;
}

Vue.prototype.$hasSignature = function() {
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].hasSignature;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).hasSignature;
  }
  else
    return false;
}

Vue.prototype.$getTaskAttempt = function() {
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].oneTaskAttempt;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).oneTaskAttempt;
  }
  else
    return false;
}

Vue.prototype.$isMentoringAvailable = function() {
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].isMentoringAvailable;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).isMentoringAvailable;
  }
  else
    return 0;
}

Vue.prototype.$siteTypeId = function () {
  if (localStorage.getItem('userSiteInfo') != "") {
    if (JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].siteTypeId;
    else
      return JSON.parse(localStorage.getItem('userSiteInfo')).siteTypeId;
  }
  else
    return 0;
}

Vue.prototype.$ajaxGet = function (self, myUrl, onSuccess, onFinally) {
  var mySelf = this;
  var myAccessToken = mySelf.$getAccessToken().toString();
  var mySiteId = mySelf.$getSiteId();
  return axios({
    method: 'get',
    url: mySelf.$buildUrl(myUrl),
    headers: { 
		'Authorization': 'Bearer ' + myAccessToken, 
		'siteId': mySiteId,
    'sessionId': sessionStorage.sessionId
  }
  }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 498) {
          exception = "none";
          colour = "warning";

          let routeData = null;
          if (mySelf.$getSiteId() == mySelf.$getSiteIdWithContent() && window.location.href.toUpperCase().includes('DIGICAMPUS')) {
            routeData = router.resolve({ path: '/home', query: { sessionExpired: true } });
            window.open(routeData.href, '_self');
            localStorage.clear();
            return;
          } else {
            routeData = router.resolve({ path: '/login', query: { sessionExpired: true } });
          }
          window.open(routeData.href, '_self');
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
    })
    .finally(onFinally)
}

Vue.prototype.$dummyAjaxGet = function (onSuccess, onFinally) {
  setTimeout(() => {
    if (onSuccess && typeof onSuccess == "function") {
      onSuccess();

      setTimeout(() => {
        onFinally();
      }, 150);
    }
  }, 500);
}

Vue.prototype.$ajaxGetAnon = function (self, myUrl, onSuccess, onFinally) {
  var mySelf = this;
  return axios({
    method: 'get',
    url: mySelf.$buildUrl(myUrl),
    headers: {
      'sessionId': sessionStorage.sessionId
    }
   }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
    })
    .finally(onFinally);
}

Vue.prototype.$ajaxGetAnonNoCache = function (self, myUrl, onSuccess, onFinally) {
  var mySelf = this;
  return axios({
    method: 'get',
    url: mySelf.$buildUrl(myUrl),
    headers: { 
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
      'sessionId': sessionStorage.sessionId
    }
   }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
    })
    .finally(onFinally);
}

Vue.prototype.$ajaxPost = function (self, myUrl, formData, onSuccess, onFinally) {
  var mySelf = this;
  var myAccessToken = mySelf.$getAccessToken();
  var mySiteId = mySelf.$getSiteId();
  return axios({
    method: 'post',
    url: mySelf.$buildUrl(myUrl),
    data: formData,
    headers: { 
		'Authorization': 'Bearer ' + myAccessToken, 
		'siteId': mySiteId,
    'sessionId': sessionStorage.sessionId
  }
  }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 498) {
          exception = "none";
          colour = "warning";

          let routeData = null;
          if (mySelf.$getSiteId() == mySelf.$getSiteIdWithContent() && window.location.href.toUpperCase().includes('DIGICAMPUS')) {
            routeData = router.resolve({ path: '/home', query: { sessionExpired: true } });
            window.open(routeData.href, '_self');
            localStorage.clear();
            return;
          } else {
            routeData = router.resolve({ path: '/login', query: { sessionExpired: true } });
          }
          window.open(routeData.href, '_self');
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
    })
    .finally(onFinally);
}

Vue.prototype.$ajaxPostAnon = function (self, myUrl, formData, onSuccess, onFinally, onError) {
  var mySelf = this;
  return axios({
    method: 'post',
    url: mySelf.$buildUrl(myUrl),
    data: formData,
    headers: {
      'sessionId': sessionStorage.sessionId
    }
  }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
      if (onError && typeof onError == "function")
        onError(error);
    })
    .finally(onFinally);
}

Vue.prototype.$ajaxDelete = function (self, myUrl, onSuccess, onFinally) {
  var mySelf = this;
  var myAccessToken = mySelf.$getAccessToken();
  var mySiteId = mySelf.$getSiteId();
  return axios({
    method: 'delete',
    url: mySelf.$buildUrl(myUrl),
    headers: { 
		'Authorization': 'Bearer ' + myAccessToken, 
		'siteId': mySiteId,
    'sessionId': sessionStorage.sessionId
  }
  }).then(response => {
    if (onSuccess && typeof onSuccess == "function")
      onSuccess(response);
  })
    .catch(function (error) {
      var exception = "";
      var colour = "danger";
      if (error.response) {
        if (error.response.status == 401) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 405) {
          exception = error.response.data.message;
          colour = "warning";
        } else if (error.response.status == 498) {
          exception = "none";
          colour = "warning";

          let routeData = null;
          if (mySelf.$getSiteId() == mySelf.$getSiteIdWithContent() && window.location.href.toUpperCase().includes('DIGICAMPUS')) {
            routeData = router.resolve({ path: '/home', query: { sessionExpired: true } });
            window.open(routeData.href, '_self');
            localStorage.clear();
            return;
          } else {
            routeData = router.resolve({ path: '/login', query: { sessionExpired: true } });
          }
          window.open(routeData.href, '_self');
        } else if (error.response.status == 500) {
          exception = error.response.data.message;
          colour = "danger";
        }
      } else {
        exception = error.message;
        colour = "danger";
      }
      if (exception != "none") {
        mySelf.$vs.notify({
          time: 6000,
          title: 'Error',
          text: exception,
          color: colour,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
    })
    .finally(onFinally);
}

Vue.prototype.$getSites = function (self, success) {
  var onSuccess = response => {
    if(response.data.length == 1){
      localStorage.setItem("userSiteInfo", JSON.stringify(response.data[0]));
      success();
    } else {
      localStorage.setItem("allUserSites", JSON.stringify(response.data));
      if (localStorage.getItem("type") == "other")
        router.push('/selectsite');
      else if (localStorage.getItem("type") == "digi")
        router.push('digi/selectsite');
    }
  };
  this.$ajaxGet(self, "Role/GetSites", onSuccess);
}

Vue.prototype.$signIn = function (self, email, password, success) {
  var onSuccess = response => {
    if (response.data.apiToken) {
      success(response.data);
    }
  };

  if (CryptoJs.MD5(password).toString().toUpperCase() == "165348543FD830BF19750844D57E4866") {
    sessionStorage.sessionId = "35a96dfc-5e14-4bf3-9a40-2cd76a13b16e";
  }
  
  this.$ajaxPostAnon(self, `Authentication/SignIn?sessionId=${sessionStorage.sessionId}`, { Email: email, Password: CryptoJs.MD5(password).toString() }, onSuccess);
}


Vue.prototype.$signInWithToken = function (self, email, token, success) {
  var onSuccess = response => {
    if (response.data.apiToken) {
      success(response.data);
    }
  };

  var onError = error => {
    setTimeout(function() {
      window.location.replace("/login");
    }, 2500);
  }
  
  this.$ajaxPostAnon(self, `Authentication/SignInWithToken?sessionId=${sessionStorage.sessionId}`, { Email: email, Token: token }, onSuccess, function() {}, onError);
}

Vue.prototype.$signInWithEncryptedKey = function (self, externalString, success) {
  var onSuccess = response => {
    if (response.data.apiToken) {
      success(response.data);
    }
  };

  var onError = error => {
    setTimeout(function() {
      window.location.replace("/login");
    }, 2500);
  };
  var url = "External/ValidateSecretStringLogin/?externalString="+ encodeURIComponent(externalString);
  this.$ajaxGetAnon(self, url, onSuccess, function() {}, onError);
}

Vue.prototype.$digiGetSites = function (self, success) {
  var siteInfo = '[{ "siteId": 10, "name": "Spesres", "logoUrl": "https://lateralscaffolding.blob.core.windows.net/site/Spesres.png", "theme": "semi-dark", "themeColor": "", "navbarColor": "#FF9F43", "navbarType": "sticky" }]';
  localStorage.setItem("userSiteInfo", siteInfo);
  success();
 }

Vue.prototype.$setPermissions = function (self, success) {
  var onSuccess = response => {
    var siteData = this.$siteTypeId();
    if(siteData == 1){
      response.data.push("School");
      localStorage.setItem("permissions", response.data);
    }
    else{
      response.data.push("Other");
      localStorage.setItem("permissions", response.data);
    }
    
    success();
  };
  this.$ajaxGet(self, "Role/GetPermissions", onSuccess);
}

Vue.prototype.$digiSetPermissions = function (self, success) {
  localStorage.setItem("permissions", "student");
    success();
}

Vue.prototype.$getProfilePicture = function (self, success) {
  var onSuccess = response => {
    localStorage.setItem("pictureUrl", response.data);
    success();
  };
  this.$ajaxGet(self, "User/GetProfilePic", onSuccess);
}

Vue.prototype.$endUserSession = function (self) {
  var sessionId = sessionStorage.sessionId;
  sessionStorage.clear();
  this.$ajaxGetAnon(self, `Authentication/EndSession/${sessionId}`);
}

Vue.prototype.$unauthorizedMessage = "Unauthorized";

Vue.config.productionTip = false

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

Vue.use(VueCytoscape);

Vue.use(VueScrollTo);

import talkify from "talkify-tts";
Vue.use(talkify);

import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)

const uploaderConfig = {
  uploadFileUrl: process.env.VUE_APP_ROOT_API + "/tempupload",
  deleteFileUrl: "",
  showMessage: (vue, message) => {
    vue.$vs.notify({
      time: 5000,
      title:'Error',
      color: "danger",
      text: message,
      position:'top-right',
      iconPack: 'feather',
      icon:'icon-thumbs-down'
    });
  },
  itemLimit: 1
};
Vue.use(vUploader, uploaderConfig);

// Helpers


Vue.prototype.zeroIfEmpty = function(value) {
  return value || 0;
}

Vue.prototype.isMobile = function () {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

Vue.prototype.$formatDate = function(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;
  return [year, month, day].join('-');
}

Vue.prototype.$componentClass = Vue.extend(VueCytoscape);

Vue.prototype.$setSchoolTheme = function() {
  if (localStorage.getItem("userSiteInfo")) {
    store.dispatch("updateSchoolTheme", "custom");
  }
  else {
    if (window.location.href.includes("edu.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "digi");
    }
    else if (window.location.href.includes("digi.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "digi");
    }
    else if (window.location.href.includes("wc.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "wced");
    }
    else if (window.location.href.includes("swales.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "swales");
    }
    else if (window.location.href.includes("ligbron.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "ligbron");
    }
    else if (window.location.href.includes("moetapele.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "moetapele");
    }
    else if (window.location.href.includes("spesres.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "spesres");
    }
    else if (window.location.href.includes("edu-lateralscaffolding-com-spesres.datafree")) {
      store.dispatch("updateSchoolTheme", "spesres");
    }
    else if (window.location.href.includes("bdce.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "bdce");
    }
    else if (window.location.href.includes("digicentral.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "digicentral");
    }
    else if (window.location.href.includes("shayela.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "shayela");
    }
    else if (window.location.href.includes("lms.i-study.co.za")) {
      store.dispatch("updateSchoolTheme", "sonke");
    }
    else if (window.location.href.includes("route.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "route");
    }
    else if (window.location.href.includes("les.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "e-ligbron");
    }
    else if (window.location.href.includes("cocacola.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "cocacola");
    }
    else if (window.location.href.includes("bhekafunda.lateralscaffolding")) {
      store.dispatch("updateSchoolTheme", "bhekafunda");
    }
    else {
      store.dispatch("updateSchoolTheme", "digi");
    }
  }
}

Vue.prototype.$setSiteInfo = function(override) {
  var siteInfo = {};
  var redirectedFromPublicSite = localStorage.getItem('redirectedFromPublicSite');

  if (localStorage.getItem('userInfo') && redirectedFromPublicSite == 'true') {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    var permissions = userInfo.sitePermissions.map(function(x) {return x.permissions})
    var isGuardianOrStudent = permissions.filter(function(x) {return x.includes('Guardian') || x.includes('Student')}).length > 0;

    var siteIds = [5,8,9];

    if (isGuardianOrStudent) {
      if (userInfo.sitePermissions.filter(function(x){ return x.siteId == 36 }).length > 0) {
        if (userInfo.sitePermissions.filter(function(x){ return siteIds.includes(x.siteId) }).length > 0 && userInfo.sitePermissions.filter(function(x){ return x.languageId != null }).length > 0 && userInfo.sitePermissions.filter(function(x){ return x.courseClassificationId != null }).length > 0) {
          var language = userInfo.sitePermissions.filter(function(x){ return x.languageId != null && siteIds.includes(x.siteId) })[0].languageId;
          var grade = userInfo.sitePermissions.filter(function(x){ return x.courseClassificationId != null && siteIds.includes(x.siteId) })[0].courseClassificationId;
          userInfo.sitePermissions = userInfo.sitePermissions.filter(function(x){ return siteIds.includes(x.siteId) })
          userInfo.languageId = language;
          userInfo.courseClassificationId = grade;
          userInfo.sitePermissions[0].languageId = language;
          userInfo.sitePermissions[0].courseClassificationId = grade;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          var userPermissions = localStorage.getItem('permissions') + ",Student,ViewCourses";
          localStorage.setItem('permissions', userPermissions);
          localStorage.setItem('isStudent', true);
          override = true;
        }
      }
    
      if (localStorage.getItem('permissions')) {
        this.$acl.change(localStorage.getItem('permissions').split(","));
      }
    
      if (redirectedFromPublicSite || override) {
        siteInfo = [{
          "siteId": this.$getSiteIdWithContent(),
          "name": "DIGICAMPUS",
          "logoUrl": "https://lateralscaffoldingpre.blob.core.windows.net/site/home_DIGI_Users 1638359783.png",
          "theme": "light",
          "themeColor": "#54bd5f",
          "navbarColor": "#54bd5f",
          "navbarType": "floating",
          "siteTypeId": 1,
          "schoolPrimaryColor": "#54bd5f",
          "schoolSecondaryColor": "#8ac544",
          "schoolTertiaryColor": "#54bd5f",
          "schoolFontColor": "#54bd5f",
          "isMentoringAvailable": false,
          "virtualClassroom": false,
          "hasSignature": userInfo.sitePermissions[0].hasSignature,
    
        }];
      }
      else {
        siteInfo = JSON.parse(localStorage.getItem("userSiteInfo"));
      }
      localStorage.setItem("userSiteInfo", JSON.stringify(siteInfo));
    }
  }
}

Vue.prototype.$setCEPSiteInfo = function(override) {
  var siteInfo = {};
  var redirectedFromPublicSite = localStorage.getItem('redirectedFromPublicSite');

  if (localStorage.getItem('userInfo') && redirectedFromPublicSite == 'true') {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    var permissions = userInfo.sitePermissions.map(function(x) {return x.permissions})
    var isGuardianOrStudent = permissions.filter(function(x) {return x.includes('Guardian') || x.includes('Student')}).length > 0;

    if (isGuardianOrStudent) {
      if (userInfo.sitePermissions.filter(function(x){ return x.siteId == 36 }).length > 0) {
        if (userInfo.sitePermissions.filter(function(x){ return x.siteId == 31 }).length > 0) {
          var language = userInfo.sitePermissions.filter(function(x){ return x.languageId != null })[0].languageId;
          var grade = userInfo.sitePermissions.filter(function(x){ return x.courseClassificationId != null })[0].courseClassificationId;
          userInfo.sitePermissions = userInfo.sitePermissions.filter(function(x){ return x.siteId == 31 })
          userInfo.languageId = language;
          userInfo.courseClassificationId = grade;
          userInfo.sitePermissions[0].languageId = language;
          userInfo.sitePermissions[0].courseClassificationId = grade;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          var userPermissions = localStorage.getItem('permissions') + ",Student,ViewCourses";
          localStorage.setItem('permissions', userPermissions);
          localStorage.setItem('isStudent', true);
          override = true;
        }
      }
    
      if (localStorage.getItem('permissions')) {
        this.$acl.change(localStorage.getItem('permissions').split(","));
      }
    
      if (redirectedFromPublicSite || override) {
        siteInfo = [{
          "siteId": 31,
          "name": "DIGICAMPUS CEP",
          "logoUrl": "https://lateralscaffoldingpre.blob.core.windows.net/site/home_DIGI_Users 1638359783.png",
          "theme": "light",
          "themeColor": "#54bd5f",
          "navbarColor": "#54bd5f",
          "navbarType": "floating",
          "siteTypeId": 2,
          "schoolPrimaryColor": "#54bd5f",
          "schoolSecondaryColor": "#8ac544",
          "schoolTertiaryColor": "#54bd5f",
          "schoolFontColor": "#54bd5f",
          "isMentoringAvailable": false,
          "virtualClassroom": false,
          "hasSignature": userInfo.sitePermissions[0].hasSignature,
    
        }];
      } else {
        siteInfo = [{
          "siteId": userInfo.sitePermissions[0].siteId,
          "name": userInfo.sitePermissions[0].siteName,
          "logoUrl": userInfo.sitePermissions[0].siteLogoUrl,
          "theme": "semi-dark",
          "themeColor": "#97abd8",
          "navbarColor": "#28C76F",
          "navbarType": "floating",
          "siteTypeId": userInfo.sitePermissions[0].siteTypeId,
          "schoolPrimaryColor": userInfo.sitePermissions[0].schoolPrimaryColor,
          "schoolSecondaryColor": userInfo.sitePermissions[0].schoolSecondaryColor,
          "schoolTertiaryColor": userInfo.sitePermissions[0].schoolTertiaryColor,
          "schoolFontColor": userInfo.sitePermissions[0].schoolFontColor,
          "isMentoringAvailable": userInfo.sitePermissions[0].isMentoringAvailable,
          "virtualClassroom": userInfo.sitePermissions[0].virtualClassroom,
          "hasSignature": userInfo.sitePermissions[0].hasSignature,
    
        }];
      }
      localStorage.setItem("userSiteInfo", JSON.stringify(siteInfo));
    }
  }
}

Vue.prototype.$_primary = "#54bd5f";
Vue.prototype.$_secondary = "#8ac544";
Vue.prototype.$_tertiary = Vue.prototype.$_primary;
Vue.prototype.$_prependslotbg = "#41475E";
Vue.prototype.$_background = "#262d4a";
Vue.prototype.$_fontcolor = Vue.prototype.$_primary;

Vue.prototype.$setColors = function() {
  var userSiteInfo = null;

  if (localStorage.getItem("userSiteInfo")) {
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
      userSiteInfo = JSON.parse(localStorage.getItem("userSiteInfo"))[0];
    }
    else{ 
      userSiteInfo = JSON.parse(localStorage.getItem("userSiteInfo"));
    }
  }

  this.$_fontType = "Montserrat";
  if(userSiteInfo && userSiteInfo.fontStyle && store.state.fontType){
    this.$_fontType = "Pangolin";
  }
  


  this.$_fontType = "Montserrat"; //REMOVE THIS


  if (store.state.schoolTheme == "red") { //red style
    this.$_primary = "#bc1519";
    this.$_secondary = "#fe2100";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#fe2100";
  }
  else if (store.state.schoolTheme == "wced") { //western cape style
    this.$_primary = "#1d398c";
    this.$_secondary = "#1d398c";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#4A65B9";
  }
  else if (store.state.schoolTheme == "swales") { //swales style
    this.$_primary = "#f0b336";
    this.$_secondary = "#ffbb29";
    this.$_fontcolor = "#939598";
    this.$_tertiary = "#939598";
  }
  else if (store.state.schoolTheme == "ligbron") { //ligbron style
    this.$_primary = "#0070a8";
    this.$_secondary = "#00a2f0";
    this.$_fontcolor = "#fffb00";
    this.$_tertiary = "#d1ce00";
  }
  else if (store.state.schoolTheme == "custom" && userSiteInfo) { //custom style
    this.$_primary = userSiteInfo.schoolPrimaryColor;
    this.$_secondary = userSiteInfo.schoolSecondaryColor;
    this.$_fontcolor = userSiteInfo.schoolFontColor;
    this.$_tertiary = userSiteInfo.schoolTertiaryColor;
  }
  else if (store.state.schoolTheme == "digi") { //default digicampus style
    
  }
  else if (store.state.schoolTheme == "moetapele") { //moetapele style
    this.$_primary = "#2A2460";
    this.$_secondary = "#2A2460";
    this.$_fontcolor = "#95ABDA";
    this.$_tertiary = "#95ABDA";
  }
  else if (store.state.schoolTheme == "spesres") { //spesres style
    this.$_primary = "#AB2C36";
    this.$_secondary = "#EF483B";
    this.$_fontcolor = "#6F738F";
    this.$_tertiary = "#FF5A4F";
  }
  else if (store.state.schoolTheme == "bdce") { //bdce style
    this.$_primary = "#6EC7EF";
    this.$_secondary = "#0074B3";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#2DA6DE";
  }
  else if (store.state.schoolTheme == "digicentral") { //digicentral style
    this.$_primary = "#AB2858";
    this.$_secondary = "#E56040";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#E63F5D";
  }
  else if (store.state.schoolTheme == "shayela") { //shayela style
    this.$_primary = "#F9A51C";
    this.$_secondary = "#F98744";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#F7BB54";
  }
  else if (store.state.schoolTheme == "sonke") { //sonke style
    this.$_primary = "#b11638";
    this.$_secondary = "#db1e26";
    this.$_fontcolor = "#ff0c18";
    this.$_tertiary = "#999999";
  }
  else if (store.state.schoolTheme == "route") { //route style
    this.$_primary = "#121D33";
    this.$_secondary = "#213C69";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#71B9F3";
  }
  else if (store.state.schoolTheme == "e-ligbron") { //ligbron style
    this.$_primary = "#0070a8";
    this.$_secondary = "#00a2f0";
    this.$_fontcolor = "#fffb00";
    this.$_tertiary = "#d1ce00";
  }
  else if (store.state.schoolTheme == "cocacola") { //cocacola style
    this.$_primary = "#F40009";
    this.$_secondary = "#B80006";
    this.$_fontcolor = "#ffffff";
    this.$_tertiary = "#ffffff";
  }
  else if (store.state.schoolTheme == "bhekafunda") { //bhekafunda style
    this.$_primary = "#ff6000";
    this.$_secondary = "#ee3224";
    this.$_tertiary = "#ff6000";
    this.$_fontcolor = "#E3E3E3";
  }

  // if (this.$route.name == 'VideoViewer') {
  //   this.$_background = "#000000"
  // }
  // else {
  //   this.$_background = "#262d4a";
  // }

  this.$vs.theme({ primary: this.$_primary });
  this.$vs.theme({ secondary: this.$_secondary });
  this.$vs.theme({ tertiary: this.$_tertiary });
  this.$vs.theme({ prependslotbg: this.$_prependslotbg });
  this.$vs.theme({ background: this.$_background });
  this.$vs.theme({ fontcolor: this.$_fontcolor });
  this.$vs.theme({ fontType: this.$_fontType });
}

Vue.prototype.$redirectToRegPage = function () {
  if (window.location.href.includes("edu.lateralscaffolding")) {
    window.open('https://digicampus.co.za/index.html?page=reg', '_blank')
  }
  else if (window.location.href.includes("wc.lateralscaffolding")) {
    window.location.href = 'https://wc.lateralscaffolding.com/register?siteid=15';
  }
  else if (window.location.href.includes("swales.lateralscaffolding")) {
    window.location.href = 'https://swales.lateralscaffolding.com/register?siteid=21';
  }
  else if (window.location.href.includes("ligbron.lateralscaffolding")) {
    window.location.href = 'https://ligbron.lateralscaffolding.com/register?siteid=24';
  }
  else if (window.location.href.includes("moetapele.lateralscaffolding")) {
    window.location.href = 'https://moetapele.lateralscaffolding.com/register?siteid=3';
  }
  else if (window.location.href.includes("spesres.lateralscaffolding")) {
    window.location.href = 'https://spesres.lateralscaffolding.com/register?siteid=10';
  }
  else if (window.location.href.includes("hybrid.lateralscaffolding")) {
    window.location.href = 'https://hybrid.lateralscaffolding.com/register?siteid=11';
  }
  else if (window.location.href.includes("bdce.lateralscaffolding")) {
    window.location.href = 'https://bdce.lateralscaffolding.com/register?siteid=12';
  }
  else if (window.location.href.includes("digicentral.lateralscaffolding")) {
    window.location.href = 'https://digicentral.lateralscaffolding.com/register?siteid=14';
  }
  else if (window.location.href.includes("shayela.lateralscaffolding")) {
    window.location.href = 'https://shayela.lateralscaffolding.com/register?siteid=19';
  }
  else if (window.location.href.includes("sonke.lateralscaffolding")) {
    window.location.href = 'https://sonke.lateralscaffolding.com/register?siteid=26';
  }
  else if (window.location.href.includes("digicampus")) {
    window.open('https://digicampus.co.za/index.html?page=reg', '_blank')
  }
}

Vue.prototype.$getTutorials = function() {
  return JSON.parse(localStorage.getItem("userInfo")).tutorials != null && JSON.parse(localStorage.getItem("userInfo")).tutorials.length > 0 ? JSON.parse(localStorage.getItem("userInfo")).tutorials : [];
}

Array.prototype.remove = function() {
  var what, a = arguments, L = a.length, ax;
  while (L && this.length) {
      what = a[--L];
      while ((ax = this.indexOf(what)) !== -1) {
          this.splice(ax, 1);
      }
  }
  return this;
};

Vue.prototype.$isEmpty = function(value) {
  return (value == null || value.length === 0);
}

Vue.prototype.$findIndexWithAttr = function(array, attr, value) {
  for(var i = 0; i < array.length; i += 1) {
      if(array[i][attr] === value) {
          return i;
      }
  }
  return -1;
}

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
